
<div mat-dialog-content style="font-family: Roboto;">
  {{message}}
 </div>
 <div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{'GENERAL.YES' | translate | uppercase}}
  </button>
   <button mat-button (click)="onNoClick()">
    {{'GENERAL.NO' | translate | uppercase}}
   </button>
   
 </div>